import '../styles/Loader.css'

const Loader = () => {
    return (
        
          <div id="loadingProgressG">
            <div id="loadingProgressG_1" className="loadingProgressG"></div>
          </div>
       
      );
}


export default Loader;